import { computed, ref } from '@nuxtjs/composition-api'

export default function useInfiniteScroll(infiniteScrollList = ref([])) {
  const infiniteScrollPageNum = ref(1)
  const infiniteScrollPageSize = ref(30)

  const isAbleToReadMore = computed(() => {
    const totalPageNum = Math.ceil(
      infiniteScrollList.value.length / infiniteScrollPageSize.value
    )
    return infiniteScrollPageNum.value < totalPageNum
  })

  function listeningToScroll(
    getTarget = () => ({
      selector: window,
      scrollHeight: () => $(document).height() - $('.js-footer').height()
    })
  ) {
    setTimeout(() => {
      const { selector, scrollHeight } = getTarget()
      $(selector).on('scroll', function() {
        if ($(this).scrollTop() + $(this).innerHeight() >= scrollHeight()) {
          readMore()
        }
      })
    }, 0)
  }

  function stopListeningToScroll(
    getTarget = () => ({
      selector: window
    })
  ) {
    const { selector } = getTarget()
    $(selector).off('scroll')
  }

  function readMore() {
    if (isAbleToReadMore.value) {
      infiniteScrollPageNum.value++
    }
    console.log('infiniteScrollPageNum:', infiniteScrollPageNum.value)
  }

  function paginate(list) {
    return list.filter(
      (_, idx) =>
        idx < infiniteScrollPageNum.value * infiniteScrollPageSize.value
    )
  }

  return {
    infiniteScrollPageNum,
    infiniteScrollPageSize,

    isAbleToReadMore,

    listeningToScroll,
    stopListeningToScroll,
    readMore,
    paginate
  }
}
